let varOptions = document.querySelectorAll(
  ".product-quick-view .variants-option input"
);
const scroll = (el, dir, scrollVal) => {
  let parentWrapper = el
    .closest(".product-quick-view-media")
    .querySelector(".product-media-content");
  let currentSlide = parentWrapper.querySelector(
    ".product-media-container.active"
  );
  let slideWidth = currentSlide.getBoundingClientRect().width;
  dir
    ? (parentWrapper.scrollLeft -= slideWidth)
    : (parentWrapper.scrollLeft += slideWidth);
  scrollVal
    ? (parentWrapper.scrollLeft = slideWidth * (Number(scrollVal) - 1))
    : "";
};
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("slide-next-quick") ||
    e.target.closest(".slide-next-quick")
  ) {
    let el = e.target.classList.contains("slide-next-quick")
      ? e.target
      : e.target.closest(".slide-next-quick");
    console.log(el);
    scroll(el, false);
  } else if (
    e.target.classList.contains("slide-prev-quick") ||
    e.target.closest(".slide-prev-quick")
  ) {
    let el = e.target.classList.contains("slide-prev-quick")
      ? e.target
      : e.target.closest(".slide-prev-quick");

    scroll(el, true);
  }
});
/////////////////////updating variant images
function updateVarImage(variant, variantBlock) {
  let media = variantBlock
    .closest(".product-quick-view-wrap")
    .querySelectorAll(".product-media-container");
  media.forEach((el, ind) => {
    let variantOpt = el.querySelector("img").getAttribute("alt");
    if (variantOpt == variant.toLowerCase()) {
      scroll(el, null, ind);
    }
  });
}
varOptions.forEach((el, ind) => {
  el.addEventListener("change", function () {
    if (el.checked) {
      let value = el.value.toLowerCase();
      updateVarImage(value);
    }
  });
});
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("quick-variant-selector") ||
    e.target.closest(".quick-variant-selector")
  ) {
    let el = e.target.classList.contains("quick-variant-selector")
      ? e.target
      : e.target.closest(".quick-variant-selector");
    let variantBlock = el;
    let inputs = el.querySelectorAll("input");
    updateVaraintForm(variantBlock);
    inputs.forEach(function (el, ind) {
      if (el.checked) {
        let value = el.value.toLowerCase();
        updateVarImage(value, variantBlock);
      }
    });
  }
});
function updateVaraintForm(element) {
  let allOptions = element.querySelectorAll('input[type="radio"]');
  let variantsData = JSON.parse(
    element
      .closest(".product-quick-view-info")
      .querySelector(
        'form[action="/cart/add"] script[type="application/ld+json"]'
      ).textContent
  );
  let formInput = element
    .closest(".product-quick-view-info")
    .querySelector('form[action="/cart/add"] input[name="id"]');
  let ajaxButton = element
    .closest(".product-quick-view-info")
    .querySelector('form[action="/cart/add"] .ajax-cart');
  console.log(variantsData);
  let selectedOptions = [];
  let selectedOptionData;
  allOptions.forEach(function (el, ind) {
    if (el.checked) {
      selectedOptions.push(el.value);
    }
  });
  variantsData.variants.forEach(function (el, ind) {
    if (
      el.options.length == selectedOptions.length &&
      el.options.every((el) => selectedOptions.indexOf(el) != -1)
    ) {
      selectedOptionData = el;
    }
  });
  formInput.value = selectedOptionData.id;
  selectedOptionData.available
    ? ajaxButton.removeAttribute("disabled")
    : ajaxButton.setAttribute("disabled", "true");
}
function updateQuantityInput(el) {
  let input = el.closest("form").querySelector(".quantity");
  let currentValue = Number(input.value);
  if (el.classList.contains("quick-qn-plus")) {
    let updateValue = currentValue + 1;
    input.value = updateValue;
  } else if (el.classList.contains("quick-qn-minus")) {
    if (currentValue <= 1) return false;
    let updateValue = currentValue - 1;
    input.value = updateValue;
  }
}
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("quick-qn-plus") ||
    e.target.closest(".quick-qn-plus")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("quick-qn-plus")
      ? e.target
      : e.target.closest(".quick-qn-plus");
    updateQuantityInput(el);
  } else if (
    e.target.classList.contains("quick-qn-minus") ||
    e.target.closest(".quick-qn-minus")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("quick-qn-minus")
      ? e.target
      : e.target.closest(".quick-qn-minus");
    updateQuantityInput(el);
  }
});
//////////////////////////rendering quick view
document.addEventListener("click", function (e) {
  if (
    e.target.classList.contains("quick-view-button") ||
    e.target.closest(".quick-view-button")
  ) {
    e.preventDefault();
    let el = e.target.classList.contains("quick-view-button")
      ? e.target
      : e.target.closest(".quick-view-button");
    let loader = el.closest("form").querySelector(".loader-wrapper");
    loader.classList.add("active");
    let url = el.dataset.product + "?view=quick-view";
    console.log(url);
    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        let parser = new DOMParser();
        let html = parser.parseFromString(data, "text/html");
        let quickViewWrap = html.querySelector(".product-quick-view");
        document.querySelector(".quick-view-wrapper").innerHTML = "";
        document
          .querySelector(".quick-view-wrapper")
          .appendChild(quickViewWrap);
        loader.classList.remove("active");
        displayQuickView();
      })
      .catch((error) => console.error(error));
  }
});
function displayQuickView() {
  document.querySelector(".quick-view-wrapper").classList.toggle("active");
  document.querySelector(".quick-view-drop").classList.toggle("active");
}
document.addEventListener("click", function (e) {
  if (
    !e.target.classList.contains("quick-view-wrapper") &&
    !e.target.closest(".quick-view-wrapper")
  ) {
    if (
      document.querySelector(".quick-view-wrapper").classList.contains("active")
    ) {
      document.querySelector(".quick-view-wrapper").classList.remove("active");
      document.querySelector(".quick-view-drop").classList.remove("active");
    }
  }
});
//////////////quantity update
document.addEventListener("click", function (e) {
  if (e.target.closest(".quick-view-wrapper")) {
    if (
      e.target.classList.contains("qn-plus") ||
      e.target.closest(".qn-plus ")
    ) {
      e.preventDefault();
      let el = e.target.classList.contains("qn-plus")
        ? e.target
        : e.target.closest(".qn-plus");
      updateValue(el, true);
    } else if (
      e.target.classList.contains("qn-minus") ||
      e.target.closest(".qn-minus ")
    ) {
      e.preventDefault();
      let el = e.target.classList.contains("qn-minus")
        ? e.target
        : e.target.closest(".qn-minus");
      updateValue(el, false);
    }
  }
});
function updateValue(el, plus) {
  let input = el.closest(".quantity-input").querySelector(".quantity");
  let currentValue = Number(input.value);
  let newValue;
  if (plus) {
    newValue = ++currentValue;
  } else {
    newValue = currentValue > 1 ? --currentValue : currentValue;
  }
  input.value = newValue;
}
